import React, { createContext, useContext, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { WatchablesFactory } from './watchables-factory';

const WatchablesFactoryContext = createContext<WatchablesFactory | null>(null);

export const WatchablesFactoryProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const queryClient = useQueryClient();
  const watchablesFactory = useMemo(
    () => new WatchablesFactory(queryClient),
    [queryClient]
  );

  return (
    <WatchablesFactoryContext.Provider value={watchablesFactory}>
      {children}
    </WatchablesFactoryContext.Provider>
  );
};

export function useWatchablesFactory(): WatchablesFactory {
  const watchablesFactory = useContext(WatchablesFactoryContext);
  if (watchablesFactory === null) {
    throw new Error('WatchablesFactoryProvider is not mounted');
  }
  return watchablesFactory;
}
